import { UserRole, UserRoleNames } from '../models/AccessControl'
import { AssignDisciplineNames, AssignStatus } from '../models/Review'

const getCategoryColor = (category: AssignDisciplineNames) => {
  switch (category) {
    case AssignDisciplineNames.Mechanical:
      return '#DD9E23'
    case AssignDisciplineNames.Electrical:
      return '#3BCBFF'
    case AssignDisciplineNames.Structural:
      return '#6B28C8'
    case AssignDisciplineNames.Plumbing:
      return '#FF2E79'
    default:
      return '#04002E'
  }
}

const getStatusColor = (
  role: UserRole | null,
  status: AssignStatus,
  completedTasksNb: number,
) => {
  switch (status) {
    case AssignStatus.NotAssigned:
      return '#97999B'
    case AssignStatus.AssignRequested:
      return role && role.name === UserRoleNames.EngineeringAdmin
        ? '#FF0000'
        : '#97999B'
    case AssignStatus.InProgress:
      return '#00C961'
    case AssignStatus.Reject:
      return '#FF0000'
    default:
      return '#04002E'
  }
}

const getProjectStatus = (status: AssignStatus) => {
  switch (status) {
    case AssignStatus.NotAssigned:
      return 'Not Assigned'
    case AssignStatus.AssignRequested:
      return 'Assign Requested'
    case AssignStatus.InProgress:
      return 'In Progress'
    case AssignStatus.Reassign:
      return 'Reassign'
    case AssignStatus.Reject:
      return 'Rejected'
    case AssignStatus.Approved:
      return 'Approved'
    default:
      return 'Status Unknown'
  }
}

const getServiceName = (category: AssignDisciplineNames) => {
  switch (category) {
    case AssignDisciplineNames.Mechanical:
    case AssignDisciplineNames.Electrical:
    case AssignDisciplineNames.Plumbing:
      return 'MEP Service'
    case AssignDisciplineNames.Structural:
      return 'Structural Service'
    default:
      return ''
  }
}

export { getCategoryColor, getStatusColor, getProjectStatus, getServiceName }
